import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent, Fragment } from "react";
import { componentStyles } from "./textarea-input.scss";
import { commonInputStyles } from "../common-inputs.scss";
import { withGenericConfig } from "/contexts/generic-config-context";
import classnames from "classnames";
class TextareaInput extends PureComponent {
    render() {
        const { inputData, errorState, onInputChange, onInputBlur, translate, invalid, errorLabelId, id, value } = this.props;
        const { inputName, isRequired, placeholder } = inputData;
        const { isValid } = errorState;
        const showRequiredError = !isValid && isRequired;
        const requiredClass = {
            "input-required": showRequiredError
        };
        return /*#__PURE__*/ _jsxs(Fragment, {
            children: [
                /*#__PURE__*/ _jsx("textarea", {
                    id: id,
                    onChange: onInputChange,
                    onBlur: onInputBlur,
                    name: inputName,
                    placeholder: translate(placeholder),
                    "aria-required": isRequired,
                    "aria-invalid": invalid,
                    "aria-describedby": errorLabelId,
                    value: value,
                    className: `jsx-${componentStyles.__hash} jsx-${commonInputStyles.__hash}` + " " + (classnames("hp-input hp-textarea-input", requiredClass) || "")
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: commonInputStyles.__hash,
                    children: commonInputStyles
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
    }
}
TextareaInput.defaultProps = {
    invalid: false,
    errorLabelId: null
};
export default withGenericConfig(TextareaInput);
